<div class="no_data_found_container">
  <img src="assets/images/no-data-found-new.svg" alt="No Data" />
  <p>
    {{ msg }}
  </p>
</div>
